import axios from "axios";
import { baseUrl } from "../config";
import { apiKey } from "../config";
class UserService {
  constructor() {}
  fetchFavorites = async (queryObject) => {
    // Example param query:
    // ?matchIds=200771623,100003621
    // &matchInclude=leagues,homeTeam,awayTeam
    // &matchFields=
    // &leagueIds=14059
    // &leagueInclude=leagues,homeTeam,awayTeam
    try {
      const response = await axios.get(`${baseUrl}/user/favorites`, {
        headers: {
          'x-signature': apiKey,
        },
        params: {
          matchIds: queryObject.matchIds,
          matchInclude: queryObject.matchInclude,
          matchFields: queryObject.matchFields,
          matchFilterOdds: queryObject.matchFilterOdds,
          leagueIds: queryObject.leagueIds,
          leagueInclude: queryObject.leagueInclude,
        },
      });

      const payload = {
        data: response.data,
      };
      return payload;
    } catch (error) {
      console.error(error);
      return { error: "Server error" };
    }
  };
}

const instance = new UserService();
export { instance as UserService };
